module.exports = __webpack_public_path__ + "static/img/default.868cd1e.jpg";